// DO NOT EDIT THIS FILE

import gql from 'graphql-tag';

export const ASSIGNE_UNDER_ORG = gql`
query assignUnderOrg($search: String) {
  assignes: me {
    id
    employee {
      id
      orgPocEmployee: organizationSet(employees_User_FirstName_Icontains: $search) {
        edges {
          node {
            id
            employees(user_FirstName: $search, user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
      orgCeoEmployee: organizationSet(employees_User_FirstName_Icontains: "*****") {
        edges {
          node {
            id
            employees(user_FirstName: $search, user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
